import { getUserInfo } from "@/assets/utils/apis";
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
// const { publicPath } = require("../../vue.config");
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);
let router = new Router({
  mode: "history",
  // base: `${publicPath}/`,
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        auth: true,
      },
      component: () => import("@/pages/home/index.vue"),
    },
    {
      path: "/main",
      name: "main",
      component: () => import("@/pages/main/Index.vue"),
      children: [
        {
          path: "/banner/build",
          name: "bannerBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/banner/build.vue"),
        },
        {
          path: "/banner/size",
          name: "bannerSize",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/banner/size-choose.vue"),
        },
        {
          path: "/cover/size",
          name: "coverSize",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/cover/size-choose.vue"),
        },
        {
          path: "/cover/build",
          name: "coverBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/cover/build.vue"),
        },
        {
          path: "/cover/decorate",
          name: "coverDecorate",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/cover/decorate.vue"),
        },
        {
          path: "/poster/build",
          name: "posterBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/poster/build-long.vue"),
        },
        {
          path: "/poster/logo-choice",
          name: "posterLogoChoice",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/poster/logo-choice.vue"),
        },
        {
          path: "/nameplate",
          name: "nameplate",
          component: () => import("@/pages/emoticon/gen-icon.vue"),
          meta: {
            auth: true,
          },
        },
        {
          path: "/tools/emotions",
          name: "emotions",
          component: () => import("@/pages/emotions/index.vue"),
          meta: {
            auth: true,
          },
        },
        {
          path: "/poster/site",
          name: "posterSite",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/poster/site-choose.vue"),
        },
        {
          path: "/skin/build",
          name: "skinBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/skin/build.vue"),
        },
        {
          path: "/sub-cover/build",
          name: "subCoverBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/sub-cover/build.vue"),
        },
        {
          path: "/sub-cover/decorate",
          name: "subCoverDecorate",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/sub-cover/decorate.vue"),
        },
        {
          path: "/design",
          name: "design",
          component: () => import("@/pages/myDesign/Index.vue"),
          children: [
            {
              path: "/banner/list",
              name: "bannerDesignList",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/BannerDesignList.vue"),
            },
            {
              path: "/banner/detail",
              name: "bannerDesignDetail",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/BannerDesignDetail.vue"),
            },
            {
              path: "/cover/list",
              name: "coverDesigns",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/CoverDesignList.vue"),
            },
            {
              path: "/poster/list",
              name: "posterDesigns",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/poster/poster-list.vue"),
            },
            {
              path: "/skin/list",
              name: "skinDesigns",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/SkinDesignList.vue"),
            },
            {
              path: "/sub-cover/list",
              name: "subCoverDesigns",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/SubCoverDesignList.vue"),
            },
            {
              path: '/popup/list',
              name: 'popupDesigns',
              meta: {
                auth: true,
              },
              component: () => import("@/pages/popup/popup-list.vue"),
            },
            {
              path: "/aipage/list",
              name: "pageDesigns",
              meta: {
                auth: true,
              },
              component: () => import("@/pages/myDesign/PageDesignList.vue"),
            },
            {
              path: "/invite-poster",
              name: "invite",
              component: () => import("@/pages/invite/Index.vue"),
              meta: {
                auth: true,
              },
            },
          ],
        },
        {
          path: "/popup/build",
          name: "popupBuild",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/popup/index.vue"),
        },
        {
          path: "/standard",
          name: "designStandard",
          component: () => import("@/pages/standard/index.vue"),
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      // 体验优化后的2.0版本，先压缩，点击之后再下载；调整质量参数的同时也进行实时压缩
      path: "/imgmin",
      name: "ImgMin",
      component: () => import("@/pages/imgMin/Index.vue"),
    },
    {
      // 原始1.0版本
      path: "/imgmin2",
      name: "ImgMin2",
      component: () => import("@/pages/imgMin/2.vue"),
    },
    {
      path: "/specific",
      name: "specific",
      component: () => import("@/pages/specific/Index.vue"),
    },
    {
      path: "/specific-cover",
      name: "specificCover",
      component: () => import("@/pages/specific/gen-cover.vue"),
    },
    {
      path: "/specific-poster",
      name: "specificPoster",
      component: () => import("@/pages/specific/gen-poster.vue"),
    },
    {
      path: "/ai",
      name: "ai",
      redirect: "/ai/guide",
      component: () => import("@/pages/ai/index.vue"),
      children: [
        {
          path: "guide",
          name: "aiGuide",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/guide.vue"),
        },
        {
          path: "/ai/generate",
          name: "aiGenerate",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/generate.vue"),
        },
        {
          path: "/ai/size-choose",
          name: "aiSizeChoose",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/size-choose.vue"),
        },
        {
          path: "/ai/poster-editor",
          name: "aiPosterEditor",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/poster-editor.vue"),
        },
        {
          path: "/ai/banner-editor",
          name: "aiBannerEditor",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/banner-editor.vue"),
        },
        {
          path: "/ai/cover-editor",
          name: "aiCoverEditor",
          meta: {
            auth: true,
          },
          component: () => import("@/pages/ai/cover-editor.vue"),
        },
        {
          path: "/ai/dialog",
          name: "aiDialog",
          component: () => import("@/pages/ai/components/ai-dialog"),
        },
      ],
    },
    {
      path: "/xbsphoto",
      name: "xbsphoto",
      component: () => import("@/pages/XBSPhoto/index.vue"),
    },
    // 任何未匹配到的路由都会跳转到welcome
    {
      path: "*",
      redirect: "/",
    },
  ],
});
router.beforeEach(async (to, from, next) => {
  // 对接知识店铺,不需要登录
  if (to.path === "/shopcenter") {
    next();
    return;
  }
  if (to.meta.auth) {
    if (!store.state.userInfo?.userId) {
      const res = await getUserInfo();
      if (res.code === 10000) {
        store.commit("changeUser", res.data);
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
